/*
  Sekcje opisowe karty produktu: taby na desktopie, akordeon na mobile.
  Jeden markup, dwie skory - o tym, ktora obowiazuje, decyduje klasa na hoscie.
  PROG musi byc taki sam jak media query w product-details-CUSTOM.css.
*/
if (!customElements.get('product-details')) {
  var PROG = 750;

  class ProductDetails extends HTMLElement {
    connectedCallback() {
      this.panele = Array.from(this.querySelectorAll('.swp__panel'));
      if (!this.panele.length) return;
      this.taby = Array.from(this.querySelectorAll('.swp__tab'));
      this.naglowki = Array.from(this.querySelectorAll('.swp__head-btn'));
      this.mq = window.matchMedia('(min-width: ' + PROG + 'px)');

      this.taby.forEach((t, i) => t.addEventListener('click', () => this.aktywuj(i)));
      this.naglowki.forEach((h, i) => h.addEventListener('click', () => this.przelacz(i)));
      this.taby.forEach((t) => t.addEventListener('keydown', (e) => this.klawisze(e)));
      this.mq.addEventListener('change', () => this.tryb());
      this.tryb();

      if (window.Shopify && window.Shopify.designMode) {
        this.addEventListener('shopify:block:select', (e) => {
          var panel = e.target.closest ? e.target.closest('.swp__panel') : null;
          var i = this.panele.indexOf(panel);
          if (i > -1) { this.aktywuj(i); this.ustawOtwarty(i, true); }
        });
      }
    }

    tryb() {
      var desktop = this.mq.matches;
      this.classList.toggle('swp--tabs', desktop);
      this.classList.toggle('swp--akordeon', !desktop);
      // role="tabpanel" bez widocznego taba jest klamstwem dla czytnika ekranu,
      // wiec na mobile ja zdejmujemy.
      this.panele.forEach((p) => {
        if (desktop) { p.setAttribute('role', 'tabpanel'); } else { p.removeAttribute('role'); }
      });
      if (desktop) {
        var akt = this.panele.findIndex((p) => p.classList.contains('is-active'));
        this.aktywuj(akt > -1 ? akt : 0);
      } else {
        this.panele.forEach((p, i) => {
          this.ustawOtwarty(i, p.dataset.otwarty === '1' || p.classList.contains('is-active'));
        });
      }
    }

    aktywuj(i) {
      this.panele.forEach((p, n) => p.classList.toggle('is-active', n === i));
      this.taby.forEach((t, n) => {
        t.setAttribute('aria-selected', n === i ? 'true' : 'false');
        t.tabIndex = n === i ? 0 : -1;
      });
    }

    ustawOtwarty(i, otwarty) {
      this.panele[i].classList.toggle('is-open', otwarty);
      if (this.naglowki[i]) {
        this.naglowki[i].setAttribute('aria-expanded', otwarty ? 'true' : 'false');
      }
    }

    przelacz(i) {
      // Rodzenstwo sie NIE zwija - to tresc do czytania, nie nawigacja.
      this.ustawOtwarty(i, !this.panele[i].classList.contains('is-open'));
    }

    klawisze(e) {
      var i = this.taby.indexOf(e.target);
      if (i < 0) return;
      var n = null;
      if (e.key === 'ArrowRight') n = (i + 1) % this.taby.length;
      if (e.key === 'ArrowLeft') n = (i - 1 + this.taby.length) % this.taby.length;
      if (e.key === 'Home') n = 0;
      if (e.key === 'End') n = this.taby.length - 1;
      if (n === null) return;
      e.preventDefault();
      this.aktywuj(n);
      this.taby[n].focus();
    }

    /*
      Kotwica: aktywuje panel, w ktorym lezy cel, i dopiero potem przewija.
      Bez tego link do tresci ukrytej za tabem nie robi nic.
    */
    pokazCel(el) {
      var panel = el.closest('.swp__panel');
      if (!panel) return false;
      var i = this.panele.indexOf(panel);
      if (i < 0) return false;
      if (this.mq.matches) { this.aktywuj(i); } else { this.ustawOtwarty(i, true); }
      var off = window.innerWidth >= PROG ? 200 : 120;
      window.requestAnimationFrame(function () {
        var y = el.getBoundingClientRect().top + window.pageYOffset - off;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
      return true;
    }
  }

  customElements.define('product-details', ProductDetails);

  function obsluzKotwice(hash) {
    if (!hash || hash.length < 2) return false;
    var cel = null;
    try { cel = document.getElementById(decodeURIComponent(hash.slice(1))); } catch (err) { return false; }
    if (!cel) return false;
    var host = cel.closest('product-details');
    return host && host.pokazCel ? host.pokazCel(cel) : false;
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href*="#"]') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    var i = href.indexOf('#');
    // samo "#" (uzywane przez inne skrypty motywu jako atrapa) zostawiamy w spokoju
    if (i < 0 || href.length - i < 2) return;
    // link prowadzacy na inna strone nie jest kotwica w tym dokumencie
    if (a.pathname && a.pathname !== window.location.pathname) return;
    if (obsluzKotwice(href.slice(i))) e.preventDefault();
  });

  window.addEventListener('hashchange', function () { obsluzKotwice(window.location.hash); });

  document.addEventListener('DOMContentLoaded', function () {
    if (window.location.hash) {
      window.setTimeout(function () { obsluzKotwice(window.location.hash); }, 60);
    }
  });
}
